<template>
  <div class="class-placement" :class="{ 'is-page-loading': loadingOverlay }">
    <div v-if="loadingOverlay" class="page-loading-overlay">
      <v-progress-circular
        indeterminate
        color="success"
        size="64"
        width="5"
      ></v-progress-circular>
    </div>
    <v-tabs v-model="viewTab" slider-color="success" class="mb-1 mx-2">
      <v-tab>Students</v-tab>
      <!-- <v-tab>Class Enrollment</v-tab> -->
      <v-tab>Classes Enrollment</v-tab>
      <v-tab>Skills Data</v-tab>
      <v-tab>Excludes Data</v-tab>
      <v-tab>Class Split Data</v-tab>
    </v-tabs>

    <div v-show="viewTab === 0" class="by-student-view mx-2">
      <div class="by-student-filters ml-2">
        <div class="toolbar-select-wrap">
          <v-select
            dense
            v-model="selectedTerm"
            :items="terms"
            label="Term"
            hide-details
            style="max-width: 130px;"
          />
        </div>
        <div class="toolbar-select-wrap">
          <v-select
            clearable
            dense
            v-model="selectedSetSplitName"
            :items="setSplitNames"
            label="Split Name"
            hide-details
            style="max-width: 180px;"
          />
        </div>
        <div class="search-input-wrap">
          <v-text-field
            dense
            v-model="byStudentSearch"
            label="Search"
            prepend-icon="mdi-magnify"
            clearable
            hide-details
            class="search-input"
          />
        </div>
        <div class="toolbar-actions">
          <v-btn
            v-if="selectedStudentIds.length"
            color="error"
            class="toolbar-action-btn ma-0"
            @click="confirmBulkDelete"
          >
            <v-icon left small>mdi-delete</v-icon>
            Delete Selected ({{ selectedStudentIds.length }})
          </v-btn>
          <v-btn
            color="success"
            class="toolbar-action-btn ma-0"
            @click="openDataDialog"
          >
            Add Data
          </v-btn>
          <school-split-export
            :all-students="allStudents"
            :term="selectedTerm"
          />
          <v-btn
            color="success"
            class="toolbar-action-btn ma-0"
            @click="openCategoryDialog"
          >
            <v-icon left small>mdi-settings</v-icon>
            Manage Categories
          </v-btn>
        </div>
      </div>

      <div v-if="!groupedByStudent.length" class="by-student-empty">
        <v-icon large color="grey lighten-1">mdi-account-multiple</v-icon>
        <div class="by-student-empty-title">No student skills found</div>
        <div class="by-student-empty-hint">
          No skills found for the selected term.
        </div>
      </div>

      <div v-else class="skill-grid-scroll">
        <div class="student-group-card skill-grid-header-row">
          <div class="student-group-side">
            <v-checkbox
              class="pa-0 pl-1 ma-0"
              color="success"
              hide-details
              :input-value="allStudentsSelected"
              :indeterminate="someStudentsSelected"
              @change="toggleSelectAll"
            />
            <div
              :title="groupedByStudent.length + ' students'"
              class="student-group-side-main pr-5"
            >
              <div class="student-avatar">
                <v-icon small color="white">mdi-account-multiple</v-icon>
              </div>

              <div class="student-id-label">
                {{ groupedByStudent.length }} students
              </div>
            </div>
          </div>
          <div class="student-flag-cards">
            <div
              v-for="category in this.skillColumns"
              :key="'h-' + category.categoryName"
              class="flag-card skill-cube skill-cube-header"
            >
              {{ category.categoryName }}
            </div>
            <div
              class="flag-card skill-cube skill-cube-header"
              style="width: 150px !important;"
            >
              Excludes
            </div>
            <div
              class="flag-card skill-cube skill-cube-header"
              style="width: 150px !important;"
            >
              Exclude By
            </div>
            <div
              v-if="selectedSetSplitName"
              class="flag-card skill-cube skill-cube-header"
            >
              Class Enrolled
            </div>
          </div>
        </div>

        <div
          v-for="group in groupedByStudent"
          :key="group.studentId"
          class="student-group-card"
        >
          <div class="student-group-side">
            <div class="pl-2">
              <v-checkbox
                color="success"
                hide-details
                v-model="selectedStudentIds"
                :value="group.studentId"
              />
              <div>
                <v-icon
                  title="Edit"
                  small
                  color="success"
                  @click="editStudent(group.studentId)"
                  >mdi-pencil</v-icon
                >
              </div>
            </div>
            <div class="student-group-side-main">
              <div title="Student Name" class="student-name-label">
                {{ group.hebFirstName + " " + group.hebLastName }}
              </div>
              <div
                class="student-photo-btn"
                title="View student photo"
                @click.stop="toggleStudentImgPreview(group.studentId)"
              >
                <v-icon size="14">mdi-camera</v-icon>
              </div>
              <div class="student-meta-row">
                <span class="student-meta-item" title="Building">
                  <v-icon size="10">mdi-domain</v-icon>{{ group.building }}
                </span>
                <span class="student-meta-item" title="Branch">
                  <v-icon size="10">mdi-source-branch</v-icon>{{ group.branch }}
                </span>
                <span class="student-meta-item" title="Class">
                  <v-icon size="10">mdi-school</v-icon>{{ group.class }}
                </span>
                <span class="student-meta-item" title="Section">
                  <v-icon size="10">mdi-shape</v-icon>{{ group.section }}
                </span>
              </div>
              <div class="student-id-row">
                <span
                  class="student-id-text"
                  style="cursor: pointer;"
                  title="Click to view student details"
                  @click="openStudentView(group.studentId)"
                  >{{ group.studentId }}</span
                >
              </div>
            </div>
          </div>

          <div class="student-flag-cards">
            <div
              v-for="cell in group.cells"
              :title="cell.categoryName ? cell.categoryName : ''"
              :key="group.studentId + '-' + cell.categoryName"
              :class="[
                'flag-card',
                'skill-cube',
                cell.item && cell.item.flag
                  ? 'skill-cube-filled'
                  : 'skill-cube-empty',
              ]"
            >
              <template v-if="cell.item && cell.item.flag">
                <div class="flag-card-top">
                  <span class="flag-card-value">{{ cell.item.flag }}</span>
                </div>
              </template>
              <template v-else>
                <span class="skill-cube-empty-label">No data</span>
              </template>
            </div>

            <div
              :class="[
                'flag-card',
                'skill-cube',
                group.excludes.length
                  ? 'skill-cube-filled'
                  : 'skill-cube-empty',
              ]"
              style="width: 150px !important;"
            >
              <div v-if="group.excludes.length" class="excludes-cell-scroll">
                <span
                  v-for="exclude in group.excludes"
                  :key="group.studentId + '-ex-' + exclude.studentId"
                  class="exclude-pill"
                  :title="exclude.studentId"
                >
                  {{ hebName(exclude) || exclude.studentId }}
                </span>
              </div>
              <span v-else class="skill-cube-empty-label">No data</span>
            </div>

            <div
              :class="[
                'flag-card',
                'skill-cube',
                group.excludeBy.length
                  ? 'skill-cube-filled'
                  : 'skill-cube-empty',
              ]"
              style="width: 150px !important;"
            >
              <div v-if="group.excludeBy.length" class="excludes-cell-scroll">
                <span
                  v-for="entry in group.excludeBy"
                  :key="group.studentId + '-by-' + entry.studentId"
                  class="exclude-pill"
                  :title="entry.studentId"
                >
                  {{ hebName(entry) || entry.studentId }}
                </span>
              </div>
              <span v-else class="skill-cube-empty-label">No data</span>
            </div>

            <div
              v-if="selectedSetSplitName"
              :class="[
                'flag-card',
                'skill-cube',
                group.enrolledToClasses.length
                  ? 'skill-cube-filled'
                  : 'skill-cube-empty',
              ]"
            >
              <template v-if="group.enrolledToClasses.length">
                <span
                  v-for="row in group.enrolledToClasses"
                  :key="group.studentId + '-cls-' + row.id"
                  class="flag-card-value"
                  style="margin: 2px 0;"
                >
                  {{ row.classNumber }}
                </span>
              </template>
              <span v-else class="skill-cube-empty-label">No data</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-show="viewTab === 1" class="mx-2">
      <SchoolSplitClassEnrollment
        :term-items="terms"
        :initial-term.sync="selectedTerm"
        :all-data="allData"
        @refresh="loadAllData"
      />
    </div> -->

    <div v-show="viewTab === 1">
      <SchoolSplitClassesView
        :term-items="terms"
        :initial-term.sync="selectedTerm"
        :set-split-names="setSplitNames"
        :initial-set-split-name.sync="selectedSetSplitName"
        :all-data="allData"
        @editStudent="editStudent"
        @refresh="onSplitRefresh"
        @generated="onSplitGenerated"
      />
    </div>

    <div v-if="viewTab === 2">
      <dx-grid
        key="school-split-grid"
        url="SchoolSplit"
        :columns="flagsColumns"
        :actions="flagActions"
        title="Skills"
        :selectionEnabled="true"
        ref="flagGrid"
        :beforeSetupGrid="beforeSetupFlagGrid"
      ></dx-grid>
    </div>

    <div v-if="viewTab === 3">
      <dx-grid
        key="school-split-excludes-grid"
        url="SchoolSplitExcludes"
        :columns="excludeColumns"
        :actions="excludeActions"
        title="Excludes"
        :selectionEnabled="true"
        ref="excludeGrid"
        :beforeSetupGrid="beforeSetupExcludeGrid"
      ></dx-grid>
    </div>

    <div v-if="viewTab === 4">
      <dx-grid
        key="school-split-classes-grid"
        url="SchoolSplitStudentClasses"
        :columns="classColumns"
        :actions="classActions"
        title="Class Split Data"
        :selectionEnabled="true"
        ref="classGrid"
      ></dx-grid>
    </div>

    <v-dialog
      content-class="dialog-top"
      persistent
      v-model="categoryDialog"
      max-width="950"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center; position: relative;"
          class="headline py-3"
        >
          Manage Categories
          <v-icon
            large
            title="Cancel"
            style="position: absolute; right: 12px;"
            color="white"
            @click="(categoryDialog = false), cancelEditCategory()"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pt-1">
          <v-btn
            v-if="!showAddForm"
            small
            color="success"
            @click="openAddCategory"
          >
            <v-icon left>mdi-plus</v-icon>
            Add New Category
          </v-btn>

          <v-form
            v-else
            style="border: 1px solid #ccc; padding: 10px; border-radius: 5px;"
            class="mt-2"
            @submit.prevent="saveCategory"
          >
            <v-layout row wrap align-center>
              <v-flex xs12 sm6 class="pr-2">
                <div class="grey--text">Add new category</div>
                <div class="category-name-row">
                  <v-text-field
                    v-model="categoryForm.categoryName"
                    label="Category Name"
                    @keyup.enter="saveCategory"
                  />
                </div>
              </v-flex>

              <v-flex xs12 sm6>
                <div class="caption grey--text">Skill Values</div>
                <div class="flags-row">
                  <v-chip
                    v-for="(flag, index) in categoryForm.flags"
                    :key="flag + index"
                    small
                    close
                    @input="removeFlag(index)"
                  >
                    {{ flag }}
                  </v-chip>

                  <v-text-field
                    ref="flagInput"
                    v-model="newFlag"
                    class="flag-input"
                    placeholder="e.g.א / 1 / A"
                    hide-details
                    single-line
                    @keyup.enter="commitFlag"
                  />

                  <v-icon
                    title="Add skill value"
                    color="success"
                    @click="onFlagPlus"
                    >mdi-plus-circle</v-icon
                  >
                </div>
              </v-flex>
            </v-layout>

            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              <v-btn
                small
                color="success"
                :loading="loading"
                @click="saveCategory"
                >Save</v-btn
              >
              <v-btn small flat @click="cancelEditCategory">Cancel</v-btn>
            </v-card-actions>
          </v-form>

          <div
            v-if="!managedCategories.length"
            class="grey--text text--darken-1 mt-3"
          >
            No categories defined yet.
          </div>

          <div v-else class="mt-3">
            <v-divider></v-divider>
            <div
              v-for="category in managedCategories"
              :key="category.id"
              class="category-row"
            >
              <v-layout
                v-if="editingCategoryId == category.id"
                row
                wrap
                align-center
              >
                <v-flex xs12 sm4 class="pr-2">
                  <div class="category-name-row">
                    <v-text-field
                      v-model="categoryForm.categoryName"
                      label="Category Name"
                      hide-details
                      @keyup.enter="saveCategory"
                    />
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <div class="flags-row">
                    <v-chip
                      v-for="(flag, index) in categoryForm.flags"
                      :key="flag + index"
                      small
                      close
                      @input="removeFlag(index)"
                    >
                      {{ flag }}
                    </v-chip>

                    <v-text-field
                      ref="flagInput"
                      v-model="newFlag"
                      class="flag-input"
                      placeholder="א / 1 / A"
                      hide-details
                      single-line
                      @keyup.enter="commitFlag"
                    />

                    <v-icon
                      title="Add skill value"
                      color="success"
                      @click="onFlagPlus"
                      >mdi-plus-circle</v-icon
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm2 class="text-xs-right">
                  <v-icon
                    title="Save"
                    color="success"
                    class="mr-2"
                    :class="{ 'mdi-spin': loading }"
                    :disabled="loading"
                    @click="saveCategory"
                    >{{ loading ? "mdi-loading" : "mdi-check" }}</v-icon
                  >
                  <v-icon title="Cancel" @click="cancelEditCategory"
                    >mdi-close</v-icon
                  >
                </v-flex>
              </v-layout>

              <v-layout v-else row align-center>
                <v-flex>
                  <div class="subheading">
                    {{ category.categoryName }}
                  </div>
                  <div>
                    <v-chip
                      v-for="flag in splitFlags(category.categoryFlag)"
                      :key="flag"
                      small
                      class="mr-1"
                    >
                      {{ flag }}
                    </v-chip>
                    <span
                      v-if="!splitFlags(category.categoryFlag).length"
                      class="grey--text"
                      >No skill values</span
                    >
                  </div>
                </v-flex>
                <v-icon
                  title="Edit"
                  class="mr-2"
                  @click="editCategory(category)"
                  >mdi-pencil</v-icon
                >
                <v-icon
                  title="Remove"
                  color="error"
                  @click="openRemoveCategoryDialog(category)"
                  >mdi-delete</v-icon
                >
              </v-layout>
              <v-divider></v-divider>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      persistent
      v-model="dataDialog"
      max-width="900"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center; position: relative;"
          class="headline py-3"
        >
          Add Data
          <v-icon
            large
            color="white"
            title="Cancel"
            style="position: absolute; right: 12px;"
            @click="(dataDialog = false), resetStudentForm()"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pt-1">
          <v-tabs ref="dataTabs" v-model="dataTab" slider-color="success">
            <v-tab>Add Students</v-tab>
            <v-tab>Upload File</v-tab>

            <v-tab-item>
              <v-form ref="addDataForm" class="student-rows-list mt-3">
                <v-layout row wrap align-end class="mt-3 px-1">
                  <v-flex xs12 sm6 md3 class="pr-2">
                    <v-select
                      v-model="selectedTerm"
                      label="Term"
                      :items="terms"
                      :menu-props="{ contentClass: 'auto-dir-menu' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-2">
                    <v-select
                      v-model="selectedClass"
                      label="Class"
                      :items="classList"
                      :loading="loadingClasses"
                      :disabled="!selectedTerm"
                      clearable
                      :menu-props="{ contentClass: 'auto-dir-menu' }"
                    />
                  </v-flex>
                </v-layout>
                <div
                  v-if="selectedTerm && selectedClass"
                  v-for="(row, rowIndex) in manualStudentRows"
                  :key="rowIndex"
                  class="student-row"
                >
                  <v-icon
                    v-if="manualStudentRows.length > 1"
                    title="Remove Row"
                    small
                    color="error"
                    class="student-row-delete"
                    @click="removeStudentRow(rowIndex)"
                    >mdi-close</v-icon
                  >
                  <div class="caption grey--text">Student Data</div>
                  <v-layout row wrap align-end>
                    <v-flex
                      v-for="item in row.fields"
                      v-if="item.field !== 'term'"
                      :key="item.field"
                      xs12
                      sm6
                      md3
                      class="pr-2"
                    >
                      <v-text-field
                        v-if="item.type !== 'select'"
                        :required="item.required"
                        :rules="[rules.required]"
                        v-model="item.value"
                        :label="item.label"
                        :error-messages="
                          item.field == 'studentId'
                            ? studentIdError(row, rowIndex)
                            : []
                        "
                      />
                      <v-autocomplete
                        v-if="item.type === 'select'"
                        :required="item.required"
                        :rules="[rules.required]"
                        v-model="item.value"
                        :label="item.label"
                        dense
                        :loading="item.field === 'studentId' && loadingStudents"
                        :items="
                          item.field === 'studentId' && !loadingStudents
                            ? availableStudentItems
                            : item.field === 'studentId' && loadingStudents
                            ? []
                            : item.items
                        "
                        :menu-props="{ contentClass: 'auto-dir-menu' }"
                      />
                    </v-flex>
                  </v-layout>

                  <div class="caption grey--text">Categories</div>
                  <v-layout row wrap>
                    <v-flex
                      v-for="category in row.categoryFlags"
                      :key="category.categoryName"
                      xs12
                      sm6
                      md3
                      class="pr-2"
                    >
                      <v-select
                        v-model="category.value"
                        :label="category.categoryName"
                        :items="category.items"
                        clearable
                        :menu-props="{ contentClass: 'auto-dir-menu' }"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap align-end>
                    <v-flex class="pr-2">
                      <div class="caption grey--text">Excludes</div>
                      <div class="flags-row excludes-input-row">
                        <v-chip
                          v-for="(excludeId, index) in row.excludeIds"
                          :key="excludeId + index"
                          small
                          close
                          @input="removeStudentExcludeChip(rowIndex, index)"
                        >
                          {{ excludeDisplayName(excludeId) || excludeId }}
                        </v-chip>

                        <v-autocomplete
                          v-model="row.newExcludeId"
                          class="exclude-input"
                          :items="
                            loadingStudents ? [] : excludeItemsForRow(row)
                          "
                          :item-text="excludeItemText"
                          item-value="studentID"
                          :loading="loadingStudents"
                          placeholder="Student"
                          hide-details
                          dense
                          single-line
                          :menu-props="{ contentClass: 'auto-dir-menu' }"
                          @change="commitStudentExcludeChip(rowIndex)"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-form>
              <v-btn
                v-if="selectedClass"
                small
                flat
                color="success"
                @click="addStudentRow"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Student
              </v-btn>
              <v-card-actions v-if="selectedClass">
                <v-btn
                  small
                  color="success"
                  :loading="loading"
                  :disabled="hasDuplicateStudentId"
                  @click="saveAddData"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-tab-item>

            <v-tab-item>
              <div class="mt-3 px-3 pt-2">
                <v-alert :value="true">
                  Upload a
                  <!-- CSV or  -->
                  Excel file with student data. The file should include columns
                  for student ID, names, class, and category scores.
                </v-alert>
                <v-btn color="success" large @click="pickFile">
                  <v-icon left>mdi-cloud-upload</v-icon>
                  Choose File (CSV / Excel)
                </v-btn>
                <input
                  ref="fileInput"
                  type="file"
                  style="display: none"
                  accept=".xlsx,.xls"
                  @change="onFilePicked"
                />
                <div v-if="uploading" class="mt-3">
                  <div class="caption grey--text mb-1">
                    Uploading... {{ uploadProgress }}%
                  </div>
                  <v-progress-linear
                    :value="uploadProgress"
                    color="success"
                    height="12"
                  />
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      persistent
      v-model="mappingDialog"
      max-width="700"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center; position: relative;"
          class="headline py-3"
        >
          Map Columns
          <v-icon
            large
            color="white"
            title="Cancel"
            style="position: absolute; right: 12px;"
            @click="cancelMapping"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pt-3">
          <v-alert :value="true" type="info" outline>
            Choose a role for each column. Exactly one column must be set as
            Student ID and exactly one as Term.
          </v-alert>
          <v-layout
            v-for="mapping in columnMappings"
            :key="mapping.index"
            row
            wrap
            align-center
            class="mapping-row"
          >
            <v-flex xs6 class="pr-2 text-truncate">
              <strong>{{
                mapping.header || "(column " + (mapping.index + 1) + ")"
              }}</strong>
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="mapping.role"
                :items="roleOptionsFor(mapping)"
                hide-details
                :menu-props="{ contentClass: 'auto-dir-menu' }"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn small flat @click="cancelMapping">Cancel</v-btn>
          <v-btn
            small
            color="success"
            :loading="loading"
            :disabled="!canConfirmMapping"
            @click="confirmMapping"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      persistent
      v-model="newCategoryDialog"
      max-width="700"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center; position: relative;"
          class="headline py-3"
        >
          New Categories / Skills
          <v-icon
            large
            color="white"
            title="Cancel"
            style="position: absolute; right: 12px;"
            @click="cancelNewCategories"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pt-3">
          <v-alert :value="true" type="info" outline>
            The following categories and skills are not in the database yet.
            They will be created on Continue.
          </v-alert>
          <div
            v-for="item in newCategoryItems"
            :key="item.categoryName"
            class="mb-3"
          >
            <div class="subheading">
              <strong>{{ item.categoryName }}</strong>
              <v-chip
                v-if="item.isNew"
                small
                color="success"
                text-color="white"
              >
                New category
              </v-chip>
            </div>
            <div class="flags-row">
              <v-chip
                v-for="flag in item.newFlags"
                :key="item.categoryName + '-' + flag"
                small
                outline
                color="success"
              >
                {{ flag }}
              </v-chip>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn small flat @click="cancelNewCategories">Cancel</v-btn>
          <v-btn
            small
            color="success"
            :loading="loading"
            @click="confirmNewCategories"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      persistent
      v-model="editDialog"
      max-width="900"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center; position: relative;"
          class="headline py-3"
        >
          Edit Student
          <v-icon
            large
            color="white"
            title="Cancel"
            style="position: absolute; right: 12px;"
            @click="closeEditStudent"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pt-1">
          <div class="student-row">
            <v-layout row wrap align-end>
              <v-flex xs12 sm3 class="pr-2">
                <v-text-field
                  :value="editForm.name"
                  label="Name"
                  readonly
                  hide-details
                />
              </v-flex>
              <v-flex xs12 sm3 class="pr-2">
                <v-text-field
                  :value="editForm.studentId"
                  label="Student ID"
                  readonly
                  hide-details
                />
              </v-flex>
              <v-flex xs12 sm3 class="pr-2">
                <v-text-field
                  :value="editForm.term"
                  label="Term"
                  readonly
                  hide-details
                />
              </v-flex>
            </v-layout>

            <v-layout row wrap class="mt-3">
              <v-flex
                v-for="(category, index) in editCategoryFlags"
                :key="category.categoryName"
                xs12
                sm6
                md3
                class="pr-2"
              >
                <v-select
                  v-if="!category.isDeletedCategory"
                  v-model="category.value"
                  :label="category.categoryName"
                  :items="category.items"
                  clearable
                  :menu-props="{ contentClass: 'auto-dir-menu' }"
                />
                <v-text-field
                  outline
                  v-else
                  :value="category.value"
                  :label="category.categoryName"
                  readonly
                  hide-details
                >
                  <template v-slot:append>
                    <v-icon
                      small
                      color="error"
                      title="This category has been deleted. Click to remove it from the student."
                      @click="removeEditDeletedCategory(index)"
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>

            <div class="caption grey--text mt-2">Exclude Students</div>
            <div class="flags-row excludes-input-row">
              <v-chip
                v-for="(exclude, index) in editExcludeIds"
                :key="exclude.studentId + index"
                small
                close
                @input="removeEditExcludeChip(index)"
              >
                {{ hebName(exclude) || exclude.studentId }}
              </v-chip>

              <v-autocomplete
                v-model="editNewExcludeId"
                class="exclude-input"
                :items="editExcludeItems"
                :item-text="excludeItemText"
                item-value="studentID"
                :loading="loadingStudents"
                placeholder="Student"
                hide-details
                dense
                single-line
                :menu-props="{ contentClass: 'auto-dir-menu' }"
                @change="commitEditExcludeChip"
              />

              <v-icon
                title="Add exclude"
                color="success"
                @click="commitEditExcludeChip"
                >mdi-plus-circle</v-icon
              >
            </div>

            <div class="caption grey--text mt-2">Enrolled to Class</div>
            <div style="max-width: 120px;">
              <v-select
                clearable
                v-model="editEnrolledClassNumber"
                :items="classNumberItems"
                label="Class"
                hide-details
                :menu-props="{ contentClass: 'auto-dir-menu' }"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            :loading="loading"
            small
            color="success"
            @click="commitEditStudent"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      v-model="classExcludeConflictDialog"
      max-width="450"
    >
      <v-card style="border: 1px solid #f57c00;">
        <v-card-title
          style="background-color: #f57c00; color: white; justify-content: center;"
          class="headline py-2"
        >
          Exclude Conflict
        </v-card-title>
        <v-card-text class="pt-4 text-xs-center">
          Moving this student to class
          <strong>{{ editEnrolledClassNumber }}</strong>
          will create exclude conflicts with:
          <div class="mt-2">
            <div v-for="name in classExcludeConflicts" :key="name" class="mb-1">
              <strong>{{ name }}</strong>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn small flat @click="classExcludeConflictDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            small
            color="warning"
            :loading="loading"
            @click="confirmClassExcludeConflict"
            >Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      v-model="deleteStudentsDialog"
      max-width="450"
    >
      <v-card style="border: 1px solid #d32f2f;">
        <v-card-title
          style="background-color: #d32f2f; color: white; justify-content: center;"
          class="headline py-2"
        >
          Confirm Delete
        </v-card-title>
        <v-card-text class="pt-4 text-xs-center">
          Are you sure you want to delete
          <strong>{{ selectedStudentIds.length }}</strong> selected student(s)
          for term <strong>{{ selectedTerm }}</strong
          >? This will remove all skills and excludes and enrolled class for
          these students in the selected term.
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn small flat @click="deleteStudentsDialog = false">Cancel</v-btn>
          <v-btn small :loading="loading" color="error" @click="deleteStudents"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      v-model="removeCategoryDialog"
      max-width="450"
    >
      <v-card style="border: 1px solid #d32f2f;">
        <v-card-title
          style="background-color: #d32f2f; color: white; justify-content: center;"
          class="headline py-2"
        >
          Confirm Delete
        </v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to remove category "{{
            categoryToDelete && categoryToDelete.categoryName
          }}"?

          <v-alert
            :value="true"
            type="warning"
            color="orange darken-3"
            style="font-size: 1.0em; color: rgba(0, 0, 0, 0.87); background-color: #fff8e1;"
            class="mt-3"
            outline
          >
            <strong>
              This only removes the category from the categories list.
            </strong>
            <br />
            Skills already entered under this category will still be included in
            newly generated splits.
            <br /><br />
            <strong>To fully exclude its data:</strong>
            <ol class="pl-4 mt-1 mb-0">
              <li>
                Go to the <strong>Skills Data</strong> tab, filter by this
                category / term, select all rows, and click
                <strong>Delete</strong>.
              </li>
              <li>
                Regenerate the split on the
                <strong>Class Enrollment</strong> tab to get the correct splits.
              </li>
            </ol>
          </v-alert>
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn small flat @click="removeCategoryDialog = false">Cancel</v-btn>
          <v-btn
            small
            color="error"
            :loading="loading"
            @click="confirmRemoveCategory"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="dialog-top"
      v-model="splitRecalcDialog"
      max-width="620"
    >
      <v-card style="border: 1px solid #5cb860;">
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center;"
          class="headline py-2"
        >
          Confirm
        </v-card-title>
        <v-card-text class="pt-4 text-xs-center">
          The data has been saved. The status of this change may affect how the
          classes were split.
          <br />
          To split according to the new data, please click the
          <strong>Generate New Split</strong>
          button in the
          <strong>Class Enrollment</strong>
          tab.
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn small color="success" @click="splitRecalcDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      v-if="previewStudentId"
      class="student-img-preview-backdrop"
      @click="closeStudentImgPreview"
    >
      <img
        :src="studentImgUrl(previewStudentId)"
        class="student-img-preview"
        alt=""
        @error="closeStudentImgPreview"
        @click.stop="closeStudentImgPreview"
      />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import SchoolSplitExport from "./SchoolSplitExport.vue";
import SchoolSplitClassesView from "./SchoolSplitClassesView.vue";
export default {
  name: "SchoolSplit",
  components: {
    SchoolSplitExport,
    SchoolSplitClassesView,
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data() {
    return {
      title: "School Split",
      previewStudentId: null,
      viewTab: 0,
      categoryDialog: false,
      categories: [],
      allStudents: [],
      loading: false,
      loadingOverlay: false,
      allData: null,
      terms: [],

      dataDialog: false,
      dataTab: null,

      mappingDialog: false,
      pendingRows: [],
      columnMappings: [],
      mappingRoleOptions: [
        { text: "Ignore", value: "ignore" },
        { text: "Student ID", value: "studentId" },
        { text: "Term", value: "term" },
        { text: "Category", value: "category" },
        { text: "Exclude", value: "exclude" },
      ],

      newCategoryDialog: false,
      newCategoryItems: [],
      parsedUploadStudents: [],

      uploading: false,
      uploadProgress: 0,

      editDialog: false,
      editForm: { studentId: "", term: "", class: "" },
      editCategoryFlags: [],
      editFlagIdsToRemove: [],
      editExcludeIds: [],
      editNewExcludeId: "",
      editEnrolledClassId: null,
      editEnrolledClassNumber: null,
      editEnrolledClassNumberOriginal: null,

      selectedStudentIds: [],
      deleteStudentsDialog: false,
      classExcludeConflictDialog: false,
      classExcludeConflicts: [],

      removeCategoryDialog: false,
      categoryToDelete: null,
      splitRecalcDialog: false,

      categoryForm: {
        categoryName: "",
        flags: [],
      },
      editingCategoryId: null,
      showAddForm: false,
      newFlag: "",
      flagActions: [],
      excludeActions: [],
      setSplitNames: [],
      selectedSetSplitName: null,
      flagsColumns: [
        {
          label: "Student ID",
          field: "studentId",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "First Name",
          field: "firstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },

        {
          label: "Last Name",
          field: "lastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish First Name",
          field: "hebFirstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish Last Name",
          field: "hebLastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Category",
          field: "category",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Flag",
          field: "flag",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Term",
          field: "term",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Class",
          field: "class",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Branch",
          field: "branch",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Section",
          field: "section",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Building",
          field: "building",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Created On",
          field: "createdOn",
          visible: true,
        },
        {
          label: "Created By",
          field: "createdBy",
          visible: true,
        },
        {
          label: "Last Updated On",
          field: "lastUpdatedOn",
          visible: true,
        },
        {
          label: "Last Updated By",
          field: "lastUpdatedBy",
          visible: true,
        },
      ],

      excludeColumns: [
        {
          label: "Student ID",
          field: "studentId",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "First Name",
          field: "firstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Last Name",
          field: "lastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish First Name",
          field: "hebFirstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish Last Name",
          field: "hebLastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Term",
          field: "term",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Class",
          field: "class",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Branch",
          field: "branch",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Section",
          field: "section",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Building",
          field: "building",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Exclude Student ID",
          field: "excludeStudentId",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Exclude First Name",
          field: "excludeFirstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Exclude Last Name",
          field: "excludeLastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Exclude Yiddish First Name",
          field: "excludeHebFirstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Exclude Yiddish Last Name",
          field: "excludeHebLastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Created On",
          field: "createdOn",
          visible: true,
        },
        {
          label: "Created By",
          field: "createdBy",
          visible: true,
        },
        {
          label: "Last Updated On",
          field: "lastUpdatedOn",
          visible: true,
        },
        {
          label: "Last Updated By",
          field: "lastUpdatedBy",
          visible: true,
        },
      ],

      classActions: [
        {
          text: "Delete Selected Rows",
          action: this.deleteSelectedClassRows,
          showOnSelection: true,
          name: "deleteSelectedClassRows",
        },
      ],
      classColumns: [
        {
          label: "Class Split Number",
          field: "classNumber",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Student ID",
          field: "studentId",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "First Name",
          field: "firstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Last Name",
          field: "lastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish First Name",
          field: "hebFirstName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Yiddish Last Name",
          field: "hebLastName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Term",
          field: "term",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Split Name",
          field: "setSplitName",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Class",
          field: "class",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Branch",
          field: "branch",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Section",
          field: "section",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Building",
          field: "building",
          visible: true,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          label: "Created On",
          field: "createdOn",
          visible: true,
        },
        {
          label: "Created By",
          field: "createdBy",
          visible: true,
        },
        {
          label: "Last Updated On",
          field: "lastUpdatedOn",
          visible: true,
        },
        {
          label: "Last Updated By",
          field: "lastUpdatedBy",
          visible: true,
        },
      ],
      manualStudentRows: [],
      selectedTerm: "",
      classList: [],
      selectedClass: "",
      allStudentsList: [],
      loadingClasses: false,
      loadingStudents: false,
      byStudentSearch: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  watch: {
    async selectedTerm() {
      localStorage.setItem("schoolSplit.selectedTerm", this.selectedTerm);
      this.selectedStudentIds = [];
      this.selectedClass = "";
      this.allStudentsList = [];
      this.manualStudentRows.forEach((row) => {
        const termField = row.fields.find((f) => f.field === "term");
        if (termField) termField.value = this.selectedTerm || "";
      });
      await this.getSetSplitNames();
      const saved = localStorage.getItem("schoolSplit.selectedSetSplitName");
      const next =
        saved && this.setSplitNames.indexOf(saved) !== -1 ? saved : null;
      if (this.selectedSetSplitName !== next) {
        this.selectedSetSplitName = next;
      } else {
        await this.loadAllData();
      }
    },
    async selectedSetSplitName() {
      if (this.selectedSetSplitName) {
        localStorage.setItem(
          "schoolSplit.selectedSetSplitName",
          this.selectedSetSplitName
        );
      } else {
        localStorage.removeItem("schoolSplit.selectedSetSplitName");
      }
      await this.loadAllData();
    },
    async selectedClass() {
      this.resetStudentForm();
      await this.loadStudentsForClass();
    },
  },
  computed: {
    hasDuplicateStudentId() {
      return this.manualStudentRows.some(
        (row, index) => this.studentIdError(row, index).length > 0
      );
    },
    hasSingleStudentIdMapping() {
      return (
        this.columnMappings.filter((m) => m.role === "studentId").length === 1
      );
    },
    hasSingleTermMapping() {
      return this.columnMappings.filter((m) => m.role === "term").length === 1;
    },
    hasCategoryOrExcludeMapping() {
      return this.columnMappings.some(
        (m) => m.role === "category" || m.role === "exclude"
      );
    },
    canConfirmMapping() {
      return (
        this.hasSingleStudentIdMapping &&
        this.hasSingleTermMapping &&
        this.hasCategoryOrExcludeMapping
      );
    },

    managedCategories() {
      return (this.categories || []).filter(
        (c) => c.existsInCategories !== false && c.id != null
      );
    },
    skillColumns() {
      return (this.categories || []).filter((c) => c.categoryName);
    },
    classNumberItems() {
      return (this.allData && this.allData.classesNumbersOnData) || [];
    },

    groupedByStudent() {
      const search = String(this.byStudentSearch || "")
        .trim()
        .toLowerCase();

      return (this.allStudents || [])
        .filter((student) => {
          if (!student.studentId) return false;

          const flags = student.flags || [];
          const excludes = student.excludes || [];
          const excludeBy = student.excludeBy || [];
          if (!flags.length && !excludes.length) return false;

          if (!search) return true;
          const haystack = [
            student.studentId,
            student.hebFirstName,
            student.hebLastName,
            student.firstName,
            student.lastName,
            student.building,
            student.class,
            student.section,
            student.branch,
            flags.map((f) => [f.category, f.flag].join(" ")).join(" "),
            excludes
              .map((e) =>
                [
                  e.studentId,
                  e.hebFirstName,
                  e.hebLastName,
                  e.firstName,
                  e.lastName,
                ].join(" ")
              )
              .join(" "),
          ]
            .join(" ")
            .toLowerCase();
          return haystack.indexOf(search) !== -1;
        })
        .slice()
        .sort((a, b) =>
          String(a.hebLastName || "").localeCompare(String(b.hebLastName || ""))
        )
        .map((student) => {
          const flags = student.flags || [];
          return {
            studentId: student.studentId,
            firstName: student.firstName,
            lastName: student.lastName,
            hebFirstName: student.hebFirstName,
            hebLastName: student.hebLastName,
            class: student.class,
            branch: student.branch,
            building: student.building,
            section: student.section,
            term: student.term,
            flags: flags,
            excludes: student.excludes || [],
            excludeBy: student.excludeBy || [],
            enrolledToClasses: (student.enrolledToClasses || []).filter(
              (row) => row.classNumber != null
            ),
            cells: this.skillColumns.map((category) => ({
              categoryName: category.categoryName,
              item:
                flags.find((f) => f.category === category.categoryName) || null,
            })),
          };
        });
    },
    availableStudentItems() {
      const existing = new Set(
        (this.allStudents || [])
          .filter((s) => {
            const flags = s.flags || [];
            const excludes = s.excludes || [];
            // Only real student rows; ignore students that appear only as someone else's exclude
            return flags.length > 0 || excludes.length > 0;
          })
          .map((s) => String(s.studentId || "").trim())
      );
      return this.allStudentsList
        .filter((s) => !existing.has(String(s.studentID || "").trim()))
        .map((s) => ({
          text: s.hebName + " " + s.lastNameH || s.studentID,
          value: String(s.studentID || "").trim(),
        }))
        .sort((a, b) => String(a.text).localeCompare(String(b.text)));
    },

    editExcludeItems() {
      const studentId = String(this.editForm.studentId || "").trim();
      const already = new Set(
        (this.editExcludeIds || []).map((exclude) =>
          String(exclude.studentId || "").trim()
        )
      );
      return this.allStudentsList.filter((item) => {
        const itemId = String(item.studentID || "").trim();
        return itemId !== studentId && !already.has(itemId);
      });
    },
    allStudentsSelected() {
      return (
        this.groupedByStudent.length > 0 &&
        this.selectedStudentIds.length === this.groupedByStudent.length
      );
    },
    someStudentsSelected() {
      return this.selectedStudentIds.length > 0 && !this.allStudentsSelected;
    },
  },
  async created() {
    this.resetStudentForm();
    await this.getRegTerms();
  },

  methods: {
    studentImgUrl(studentId) {
      return (
        "https://attendance.wiseaccesstech.com/api/Attendance/GetStudentImg?school=UTA&studentId=" +
        encodeURIComponent(studentId)
      );
    },
    toggleStudentImgPreview(studentId) {
      this.previewStudentId =
        this.previewStudentId === studentId ? null : studentId;
    },
    closeStudentImgPreview() {
      this.previewStudentId = null;
    },
    async getRegTerms() {
      this.terms = (await this.$http.get("api/allStudents/getRegTerms")) || [];
      this.selectedTerm =
        localStorage.getItem("schoolSplit.selectedTerm") ||
        this.terms[this.terms.length - 1];
    },
    async getSetSplitNames() {
      if (!this.selectedTerm) {
        this.setSplitNames = [];
        return;
      }
      this.setSplitNames =
        (await this.$http.get(
          `api/SchoolSplit/GetSetSplitNames?term=${encodeURIComponent(
            this.selectedTerm
          )}`
        )) || [];
    },
    async onSplitGenerated(setSplitName) {
      await this.getSetSplitNames();
      this.selectedSetSplitName = setSplitName;
    },
    async onSplitRefresh() {
      await this.getSetSplitNames();
      if (
        this.selectedSetSplitName &&
        this.setSplitNames.indexOf(this.selectedSetSplitName) === -1
      ) {
        this.selectedSetSplitName = null;
      } else {
        await this.loadAllData();
      }
    },
    beforeSetupFlagGrid() {
      this.flagActions = [
        {
          text: "Delete Selected Rows",
          action: this.deleteSelectedFlagRows,
          showOnSelection: true,
          name: "deleteSelectedFlagRows",
        },
      ];
    },
    async deleteSelectedFlagRows() {
      const selectedRows = this.$refs.flagGrid.getSelectedRowsData();
      const ids = selectedRows.map((row) => row.id);
      const confirmed = confirm(
        `Are you sure you want to delete these ${ids.length} selected rows?`
      );
      if (!confirmed) return;
      await this.deleteStudentFlag(ids);
      await this.loadAllData();
      await this.$refs.flagGrid.reloadGrid();
      this.notifySuccess("Selected rows deleted successfully.");
      this.showSplitRecalcDialog();
    },
    beforeSetupExcludeGrid() {
      this.excludeActions = [
        {
          text: "Delete Selected Rows",
          action: this.deleteSelectedExcludeRows,
          showOnSelection: true,
          name: "deleteSelectedExcludeRows",
        },
      ];
    },
    async deleteSelectedExcludeRows() {
      const selectedRows = this.$refs.excludeGrid.getSelectedRowsData();
      const ids = selectedRows.map((row) => row.id);
      await this.apiDeleteExcludes(ids);
      await this.loadAllData();
      await this.$refs.excludeGrid.reloadGrid();
      this.notifySuccess("Selected rows deleted successfully.");
      this.showSplitRecalcDialog();
    },

    async deleteSelectedClassRows() {
      const selectedRows = this.$refs.classGrid.getSelectedRowsData();
      const ids = selectedRows.map((row) => row.id);
      if (!ids.length) return;
      const confirmed = confirm(
        `Are you sure you want to delete these ${ids.length} selected rows?`
      );
      if (!confirmed) return;
      const result = await this.apiDeleteClassRows(ids);
      if (!result) return;
      await this.$refs.classGrid.reloadGrid();
      const term =
        localStorage.getItem("schoolSplit.selectedTerm") ||
        this.terms[this.terms.length - 1];
      this.selectedTerm = null;
      await this.$nextTick();
      this.selectedTerm = term;
      await this.loadAllData();
      this.notifySuccess("Selected rows deleted successfully.");
    },

    async loadAllData() {
      this.loadingOverlay = true;
      try {
        const response = await this.apiGetAll();
        const data = (response && response.data) || response || {};
        this.allData = data;
        this.allStudents = data.allStudents || [];
        this.categories = (data.categories || []).sort((a, b) =>
          String(a.categoryName || "").localeCompare(
            String(b.categoryName || "")
          )
        );
      } finally {
        this.loadingOverlay = false;
      }
    },

    async openCategoryDialog() {
      if (this.managedCategories.length === 0) {
        await this.loadAllData();
      }
      this.categoryDialog = true;
    },

    async openDataDialog() {
      this.resetStudentForm();
      this.selectedClass = "";
      this.allStudentsList = [];
      this.dataTab = 0;
      this.dataDialog = true;
      if (this.selectedTerm) {
        await this.loadClassesForTerm();
      }
      this.$nextTick(() => {
        if (this.$refs.dataTabs) {
          this.$refs.dataTabs.callSlider();
        }
      });
    },
    async loadClassesForTerm() {
      if (!this.selectedTerm) {
        this.classList = [];
        return;
      }
      this.loadingClasses = true;
      try {
        this.classList =
          (await this.$http.get(
            `api/SchoolSplit/GetGradesByTerm?term=${this.selectedTerm}`
          )) || [];
      } catch (error) {
        this.classList = [];
        this.notifyError("Failed to load classes.");
      } finally {
        this.loadingClasses = false;
      }
    },
    async loadStudentsForClass() {
      this.allStudentsList = [];
      if (!this.selectedTerm || !this.selectedClass) {
        return;
      }
      this.loadingStudents = true;
      try {
        const cls = String(this.selectedClass || "").toLowerCase();
        const url = `api/SchoolSplit/GetStudentsList?term=${
          this.selectedTerm
        }&grade=${cls}`;
        const response = await this.$http.get(url);
        this.allStudentsList = response || [];
      } catch (error) {
        this.allStudentsList = [];
        this.notifyError("Failed to load students.");
      } finally {
        this.loadingStudents = false;
      }
    },
    createStudentFormRow() {
      const row = {
        fields: [],
        excludeIds: [],
        newExcludeId: "",
        categoryFlags: [],
      };
      row.fields = [
        {
          field: "studentId",
          label: "Student Name",
          value: "",
          required: true,
          type: "select",
          items: [],
          action: null,
        },
        {
          field: "term",
          label: "Term",
          value: this.selectedTerm || "",
          required: true,
          action: null,
          type: "select",
          items: this.terms,
        },
      ];
      row.categoryFlags = this.managedCategories.map((category) => ({
        categoryName: category.categoryName,
        items: this.splitFlags(category.categoryFlag),
        value: "",
      }));
      return row;
    },
    resetStudentForm() {
      this.manualStudentRows = [this.createStudentFormRow()];
    },
    addStudentRow() {
      this.manualStudentRows.push(this.createStudentFormRow());
    },
    removeStudentRow(index) {
      if (this.manualStudentRows.length <= 1) return;
      this.manualStudentRows.splice(index, 1);
    },
    getRowValue(row, field) {
      const item = row.fields.find((entry) => entry.field == field);
      return item ? item.value : "";
    },
    studentIdError(row, rowIndex) {
      const studentId = String(this.getRowValue(row, "studentId") || "").trim();
      if (!studentId) return [];
      const term = String(this.getRowValue(row, "term") || "").trim();

      const existsInDb = (this.allStudents || []).some((student) => {
        const flags = student.flags || [];
        const excludes = student.excludes || [];
        // Ignore students that appear only as someone else's exclude
        if (!flags.length && !excludes.length) return false;
        return (
          String(student.studentId || "").trim() === studentId &&
          String(student.term || "").trim() === term
        );
      });
      if (existsInDb) {
        return ["Student ID already exists."];
      }

      const duplicateInForm = this.manualStudentRows.some((otherRow, index) => {
        if (index === rowIndex) return false;
        return (
          String(this.getRowValue(otherRow, "studentId") || "").trim() ===
            studentId &&
          String(this.getRowValue(otherRow, "term") || "").trim() === term
        );
      });
      if (duplicateInForm) {
        return ["Duplicate Student ID."];
      }

      return [];
    },
    commitStudentExcludeChip(rowIndex) {
      const row = this.manualStudentRows[rowIndex];
      if (!row) return;

      const excludeId = String(row.newExcludeId || "").trim();
      row.newExcludeId = "";
      if (!excludeId) return;

      if (row.excludeIds.includes(excludeId)) {
        this.notifyError("Exclude already exists in the list.");
        return;
      }

      const studentId = String(this.getRowValue(row, "studentId") || "").trim();
      if (studentId && excludeId === studentId) {
        this.notifyError("Student cannot exclude themselves.");
        return;
      }

      row.excludeIds.push(excludeId);
    },
    removeStudentExcludeChip(rowIndex, chipIndex) {
      const row = this.manualStudentRows[rowIndex];
      if (!row) return;
      row.excludeIds.splice(chipIndex, 1);
    },
    excludeItemsForRow(row) {
      const studentId = String(this.getRowValue(row, "studentId") || "").trim();
      const already = new Set(
        (row.excludeIds || []).map((id) => String(id || "").trim())
      );
      const result = this.allStudentsList.filter((item) => {
        const itemId = String(item.studentID || "").trim();
        return itemId !== studentId && !already.has(itemId);
      });
      return result.sort((a, b) =>
        String(a.hebName).localeCompare(String(b.hebName))
      );
    },

    hebName(person) {
      if (!person) return "";
      return (
        String(person.hebFirstName || "").trim() +
        " " +
        String(person.hebLastName || "").trim()
      ).trim();
    },
    excludeItemText(item) {
      return `${item.hebName || ""} ${item.lastNameH || ""}`.trim();
    },
    excludeDisplayName(id) {
      const key = String(id || "").trim();
      const match = this.allStudentsList.find(
        (s) => String(s.studentID || "").trim() === key
      );
      return match ? this.excludeItemText(match) : "";
    },
    findStudent(studentId) {
      const id = String(studentId || "").trim();
      return (this.allStudents || []).find(
        (s) => String(s.studentId || "").trim() === id
      );
    },
    normalizeCategoryName(name) {
      return String(name || "").trim();
    },
    splitFlags(categoryFlag) {
      return String(categoryFlag || "")
        .split(",")
        .map((flag) => flag.trim())
        .filter(Boolean);
    },
    onFlagPlus() {
      this.commitFlag();
    },
    commitFlag() {
      const flag = this.normalizeCategoryName(this.newFlag);
      this.newFlag = "";

      if (!flag) return;

      if (this.categoryForm.flags.includes(flag)) {
        this.notifyError("Value already exists.");
        return;
      }

      this.categoryForm.flags.push(flag);
      this.$nextTick(() => {
        if (this.$refs.flagInput) {
          this.$refs.flagInput.focus();
        }
      });
    },
    removeFlag(index) {
      this.categoryForm.flags.splice(index, 1);
    },
    async saveCategory() {
      this.commitFlag();

      const name = this.normalizeCategoryName(this.categoryForm.categoryName);
      if (!name) {
        this.notifyError("Category name is required.");
        return;
      }

      const exists = this.managedCategories.some(
        (category) =>
          category.categoryName == name && category.id != this.editingCategoryId
      );
      if (exists) {
        this.notifyError("Category already exists.");
        return;
      }

      const payload = {
        id: this.editingCategoryId || 0,
        categoryName: name,
        categoryFlag: this.categoryForm.flags
          .map((flag) => this.normalizeCategoryName(flag))
          .filter(Boolean)
          .join(","),
        sortOrder: null,
      };

      if (this.editingCategoryId) {
        await this.apiUpdateCategory(payload);
        this.notifySuccess("Category updated successfully.");
      } else {
        await this.apiAddCategory(payload);
        this.notifySuccess("Category added successfully.");
      }

      await this.loadAllData();
      this.cancelEditCategory();
    },
    openAddCategory() {
      this.cancelEditCategory();
      this.showAddForm = true;
    },
    editCategory(category) {
      this.cancelEditCategory();
      this.editingCategoryId = category.id;
      this.categoryForm.categoryName = category.categoryName;
      this.categoryForm.flags = this.splitFlags(category.categoryFlag);
    },
    cancelEditCategory() {
      this.editingCategoryId = null;
      this.showAddForm = false;
      this.categoryForm.categoryName = "";
      this.categoryForm.flags = [];
      this.newFlag = "";
    },
    openRemoveCategoryDialog(category) {
      this.categoryToDelete = category;
      this.removeCategoryDialog = true;
    },
    async confirmRemoveCategory() {
      if (!this.categoryToDelete) return;
      const id = this.categoryToDelete.id;
      await this.apiDeleteCategory(id);
      this.removeCategoryDialog = false;
      this.categoryToDelete = null;
      await this.loadAllData();
      this.notifySuccess("Category removed successfully.");
    },
    pickFile() {
      this.$refs.fileInput.click();
    },
    async onFilePicked(event) {
      const files = event.target.files;
      if (!files || !files.length) return;

      const file = files[0];

      try {
        const rows = await this.parseFileToRows(file);
        this.openMappingDialog(rows);
      } catch (e) {
        this.notifyError("Failed to parse file.");
      } finally {
        event.target.value = "";
      }
    },
    openMappingDialog(rows) {
      if (!Array.isArray(rows) || rows.length < 2) {
        this.notifyError("File has no data rows.");
        return;
      }

      const headers = rows[0] || [];
      this.pendingRows = rows;

      let studentIdAssigned = false;
      let termAssigned = false;
      this.columnMappings = headers.map((header, index) => {
        const name = this.normalizeCategoryName(header);
        let role = this.guessRoleForHeader(name);
        if (role === "studentId") {
          if (studentIdAssigned) role = "ignore";
          else studentIdAssigned = true;
        } else if (role === "term") {
          if (termAssigned) role = "ignore";
          else termAssigned = true;
        }
        return { index, header: name, role };
      });
      this.mappingDialog = true;
    },
    guessRoleForHeader(header) {
      const name = this.normalizeCategoryName(header);
      if (!name) return "ignore";
      const lower = name.toLowerCase();

      if (lower === "id" || lower === "student id" || lower === "studentid") {
        return "studentId";
      }
      if (lower === "term") {
        return "term";
      }
      if (lower.startsWith("exclude") || name.startsWith("נישט צוזאמען")) {
        return "exclude";
      }
      const matchesCategory = this.managedCategories.some(
        (c) =>
          this.normalizeCategoryName(c.categoryName).toLowerCase() === lower
      );
      if (matchesCategory) {
        return "category";
      }

      return "ignore";
    },
    roleOptionsFor(mapping) {
      const singleRoles = ["studentId", "term"];
      return this.mappingRoleOptions.filter((option) => {
        if (!singleRoles.includes(option.value)) return true;
        if (mapping.role === option.value) return true;
        return !this.columnMappings.some(
          (m) => m.index !== mapping.index && m.role === option.value
        );
      });
    },
    cancelMapping() {
      this.mappingDialog = false;
      this.pendingRows = [];
      this.columnMappings = [];
      this.parsedUploadStudents = [];
    },
    async confirmMapping() {
      if (!this.canConfirmMapping) {
        this.notifyError(
          "Please select exactly one Student ID column and one Term column."
        );
        return;
      }

      this.parsedUploadStudents = this.buildMappedStudents();
      if (!this.parsedUploadStudents.length) {
        this.notifyError("No valid student rows found.");
        return;
      }

      this.mappingDialog = false;

      const news = this.computeNewCategoriesAndFlags();
      if (news.length) {
        this.newCategoryItems = news;
        this.newCategoryDialog = true;
      } else {
        await this.saveUploadedData();
      }
    },
    parseFileToRows(file) {
      const extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      //   if (extension == "csv") {
      //     return this.parseCsv(file);
      //   }

      return this.parseExcel(file);
    },
    parseExcel(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const workbook = XLSX.read(e.target.result, {
              type: "array",
            });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              defval: "",
              raw: false,
            });
            resolve(rows);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },

    buildMappedStudents() {
      const rows = this.pendingRows;
      if (!Array.isArray(rows) || rows.length < 2) {
        return [];
      }

      const studentIdMapping = this.columnMappings.find(
        (m) => m.role === "studentId"
      );
      const termMapping = this.columnMappings.find((m) => m.role === "term");
      const categoryMappings = this.columnMappings.filter(
        (m) => m.role === "category"
      );
      const excludeMappings = this.columnMappings.filter(
        (m) => m.role === "exclude"
      );

      const parsedStudents = [];
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        if (!row || !row.length) continue;

        const studentId = String(row[studentIdMapping.index] || "").trim();
        if (!studentId) {
          continue;
        }

        const term = termMapping
          ? String(row[termMapping.index] || "").trim()
          : "";

        const categoryFlags = [];
        categoryMappings.forEach((mapping) => {
          const flag = this.normalizeCategoryName(row[mapping.index]);
          if (flag) {
            categoryFlags.push({ category: mapping.header, flag: flag });
          }
        });

        const excludeIds = [];
        excludeMappings.forEach((mapping) => {
          const excludeId = this.normalizeCategoryName(row[mapping.index]);
          if (excludeId && excludeId !== studentId) {
            excludeIds.push(excludeId);
          }
        });

        parsedStudents.push({
          studentId: studentId,
          term: term,
          categoryFlags: categoryFlags,
          excludeIds: excludeIds,
        });
      }

      return parsedStudents;
    },
    computeNewCategoriesAndFlags() {
      const collected = {};
      this.parsedUploadStudents.forEach((student) => {
        student.categoryFlags.forEach((pair) => {
          const name = this.normalizeCategoryName(pair.category);
          const flag = this.normalizeCategoryName(pair.flag);
          if (!name || !flag) return;
          if (!collected[name]) {
            collected[name] = { categoryName: name, flags: [] };
          }
          if (
            !collected[name].flags.some(
              (f) => f.toLowerCase() === flag.toLowerCase()
            )
          ) {
            collected[name].flags.push(flag);
          }
        });
      });

      const items = [];
      Object.keys(collected).forEach((name) => {
        const entry = collected[name];
        const existing = this.managedCategories.find(
          (c) =>
            this.normalizeCategoryName(c.categoryName).toLowerCase() ===
            name.toLowerCase()
        );

        if (!existing) {
          items.push({
            categoryName: entry.categoryName,
            isNew: true,
            existing: null,
            newFlags: entry.flags,
          });
          return;
        }

        const existingFlags = this.splitFlags(existing.categoryFlag);
        const newFlags = entry.flags.filter(
          (flag) =>
            !existingFlags.some((ef) => ef.toLowerCase() === flag.toLowerCase())
        );
        if (newFlags.length) {
          items.push({
            categoryName: existing.categoryName,
            isNew: false,
            existing: existing,
            newFlags: newFlags,
          });
        }
      });

      return items;
    },
    cancelNewCategories() {
      this.newCategoryDialog = false;
      this.newCategoryItems = [];
      this.pendingRows = [];
      this.columnMappings = [];
      this.parsedUploadStudents = [];
    },
    async confirmNewCategories() {
      const promises = [];
      this.newCategoryItems.forEach((item) => {
        if (item.isNew) {
          promises.push(
            this.apiAddCategory({
              id: 0,
              categoryName: item.categoryName,
              categoryFlag: item.newFlags.join(","),
              sortOrder: null,
            })
          );
        } else {
          const existingFlags = this.splitFlags(item.existing.categoryFlag);
          const mergedFlags = existingFlags.concat(item.newFlags);
          promises.push(
            this.apiUpdateCategory({
              id: item.existing.id,
              categoryName: item.existing.categoryName,
              categoryFlag: mergedFlags.join(","),
              sortOrder: item.existing.sortOrder,
            })
          );
        }
      });

      await Promise.all(promises);
      await this.loadAllData();
      this.newCategoryDialog = false;
      this.newCategoryItems = [];
      await this.saveUploadedData();
    },
    async saveUploadedData() {
      const flagPayload = [];
      const excludePayload = [];

      this.parsedUploadStudents.forEach((student) => {
        student.categoryFlags.forEach((pair) => {
          flagPayload.push({
            studentId: student.studentId,
            term: student.term,
            category: pair.category,
            flag: pair.flag,
          });
        });

        student.excludeIds.forEach((excludeId) => {
          excludePayload.push({
            studentId: student.studentId,
            excludeStudentId: excludeId,
            term: student.term,
          });
        });
      });

      if (!flagPayload.length && !excludePayload.length) {
        this.notifyError("No data to save.");
        return;
      }

      const chunkSize = 30;
      const flagChunks = this.chunkArray(flagPayload, chunkSize);
      const excludeChunks = this.chunkArray(excludePayload, chunkSize);
      const totalChunks = flagChunks.length + excludeChunks.length;
      let processedChunks = 0;

      this.uploading = true;
      this.uploadProgress = 0;

      try {
        for (let i = 0; i < flagChunks.length; i++) {
          await this.apiAddStudentFlag(flagChunks[i]);
          processedChunks++;
          this.uploadProgress = Math.round(
            (processedChunks / totalChunks) * 100
          );
        }
        for (let i = 0; i < excludeChunks.length; i++) {
          await this.apiAddExcludes(excludeChunks[i]);
          processedChunks++;
          this.uploadProgress = Math.round(
            (processedChunks / totalChunks) * 100
          );
        }
      } finally {
        this.uploading = false;
      }

      await this.loadAllData();
      this.notifySuccess("Student data saved successfully.");
      this.showSplitRecalcDialog();

      this.pendingRows = [];
      this.columnMappings = [];
      this.parsedUploadStudents = [];
      this.dataDialog = false;
    },
    chunkArray(items, size) {
      const chunks = [];
      for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
      }
      return chunks;
    },

    async addSkills(options = {}) {
      const {
        showSuccess = true,
        resetForm = true,
        showSplitWarning = true,
      } = options;
      const payloads = [];

      for (let i = 0; i < this.manualStudentRows.length; i++) {
        const row = this.manualStudentRows[i];
        const studentId = String(
          this.getRowValue(row, "studentId") || ""
        ).trim();
        const term = String(this.getRowValue(row, "term") || "").trim();

        const rowFlagPairs = (row.categoryFlags || [])
          .filter((category) => String(category.value || "").trim())
          .map((category) => ({
            category: category.categoryName,
            flag: String(category.value || "").trim(),
          }));

        if (!rowFlagPairs.length) continue;

        if (!studentId) {
          this.notifyError("Student ID is required for rows with skills.");
          return null;
        }

        rowFlagPairs.forEach((pair) => {
          payloads.push({
            studentId: studentId,
            term: term,
            category: pair.category,
            flag: pair.flag,
          });
        });
      }

      if (!payloads.length) {
        return false;
      }

      await this.apiAddStudentFlag(payloads);
      if (showSuccess) {
        this.notifySuccess(
          payloads.length === 1
            ? "Student added successfully."
            : `${payloads.length} students added successfully.`
        );
      }
      if (this.$refs.grid) {
        this.$refs.grid.reloadGrid();
      }
      if (resetForm) {
        this.resetStudentForm();
      }
      if (showSplitWarning) {
        this.showSplitRecalcDialog();
      }
      return true;
    },
    async saveStudentRowExcludes(options = {}) {
      const { showSuccess = true, showSplitWarning = true } = options;

      this.manualStudentRows.forEach((row, index) => {
        this.commitStudentExcludeChip(index);
      });

      const rowsToProcess = this.manualStudentRows.filter((row) => {
        const hasStudentId = String(
          this.getRowValue(row, "studentId") || ""
        ).trim();
        const hasTerm = String(this.getRowValue(row, "term") || "").trim();
        const hasNewExclude = String(row.newExcludeId || "").trim();
        return (
          row.excludeIds.length > 0 ||
          (hasStudentId && hasTerm && hasNewExclude)
        );
      });

      if (!rowsToProcess.length) {
        return false;
      }

      const payload = [];
      const seenInForm = {};

      for (let i = 0; i < rowsToProcess.length; i++) {
        const row = rowsToProcess[i];
        const studentId = String(
          this.getRowValue(row, "studentId") || ""
        ).trim();
        const term = String(this.getRowValue(row, "term") || "").trim();
        if (!studentId || !term) {
          this.notifyError("Student ID and Term are required.");
          return null;
        }

        const student = this.findStudent(studentId);
        const existingExcludeIds = ((student && student.excludes) || []).map(
          (e) => String(e.studentId || "").trim()
        );

        row.excludeIds.forEach((id) => {
          const excludeStudentId = String(id || "").trim();
          if (!excludeStudentId || excludeStudentId === studentId) return;

          const key = studentId + "|" + term + "|" + excludeStudentId;
          if (seenInForm[key]) return;
          if (existingExcludeIds.indexOf(excludeStudentId) !== -1) return;

          seenInForm[key] = true;
          payload.push({
            studentId: studentId,
            excludeStudentId: excludeStudentId,
            term: term,
          });
        });
      }

      if (!payload.length) {
        this.notifyError("All selected excludes already exist.");
        return null;
      }

      await this.apiAddExcludes(payload);
      if (showSuccess) {
        this.notifySuccess(
          payload.length === 1
            ? "Exclude added successfully."
            : `${payload.length} excludes added successfully.`
        );
      }
      if (showSplitWarning) {
        this.showSplitRecalcDialog();
      }
      return true;
    },
    async saveAddData() {
      if (!this.$refs.addDataForm.validate()) {
        return;
      }
      const hasFlagsData = this.manualStudentRows.some((row) => {
        return (row.categoryFlags || []).some((category) =>
          String(category.value || "").trim()
        );
      });
      const hasExcludesData = this.manualStudentRows.some((row) => {
        return (
          row.excludeIds.length > 0 || String(row.newExcludeId || "").trim()
        );
      });

      if (!hasFlagsData) {
        this.notifyError("Please fill at least one field.");
        return;
      }
      const flagsSaved = hasFlagsData
        ? await this.addSkills({
            showSuccess: false,
            resetForm: false,
            showSplitWarning: false,
          })
        : false;
      if (flagsSaved === null) return;

      const excludesSaved = hasExcludesData
        ? await this.saveStudentRowExcludes({
            showSuccess: false,
            showSplitWarning: false,
          })
        : false;
      if (excludesSaved === null) return;

      const savedCount = [flagsSaved, excludesSaved].filter(Boolean).length;
      if (!savedCount) return;

      if (savedCount === 2) {
        this.notifySuccess("Skills and excludes saved successfully.");
      } else if (flagsSaved) {
        this.notifySuccess("Student added successfully.");
      } else if (excludesSaved) {
        this.notifySuccess("Exclude added successfully.");
      }

      await this.loadAllData();
      this.resetStudentForm();
      this.dataDialog = false;
      this.showSplitRecalcDialog();
    },
    editStudent(studentId) {
      const group = this.groupedByStudent.find(
        (g) => g.studentId === studentId
      );
      if (!group) return;

      this.editForm.class = group.class;
      this.editForm.name = `${group.hebFirstName} ${group.hebLastName}`;
      this.editForm.studentId = studentId;
      this.editForm.term = this.selectedTerm;

      this.editFlagIdsToRemove = [];
      this.editCategoryFlags = this.skillColumns
        .map((category) => {
          const cell = group.cells.find(
            (c) => c.categoryName === category.categoryName
          );
          const item = (cell && cell.item) || null;
          const isDeletedCategory =
            category.existsInCategories === false || category.id == null;
          if (isDeletedCategory && !item) return null;
          return {
            categoryName: category.categoryName,
            items: this.splitFlags(category.categoryFlag),
            value: item ? item.flag : "",
            isDeletedCategory: isDeletedCategory,
            flagId: item && item.id,
          };
        })
        .filter(Boolean);

      this.editExcludeIds = [...group.excludes];
      this.editNewExcludeId = "";
      const enrolled = (group.enrolledToClasses || [])[0] || null;
      this.editEnrolledClassId = enrolled ? enrolled.id : null;
      this.editEnrolledClassNumber = enrolled ? enrolled.classNumber : null;
      this.editEnrolledClassNumberOriginal = this.editEnrolledClassNumber;
      this.selectedClass = this.editForm.class;
      this.loadStudentsForClass();
      this.editDialog = true;
    },
    removeEditExcludeChip(index) {
      this.editExcludeIds.splice(index, 1);
    },
    commitEditExcludeChip() {
      const excludeId = String(this.editNewExcludeId || "").trim();
      this.editNewExcludeId = "";
      if (!excludeId) return;

      if (
        this.editExcludeIds.some(
          (exclude) => String(exclude.studentId || "").trim() === excludeId
        )
      ) {
        this.notifyError("Exclude already exists in the list.");
        return;
      }

      if (excludeId === this.editForm.studentId) {
        this.notifyError("Student cannot exclude themselves.");
        return;
      }

      const match = this.allStudentsList.find(
        (item) => String(item.studentID || "").trim() === excludeId
      );
      this.editExcludeIds.push({
        studentId: excludeId,
        hebFirstName: match ? match.hebName : "",
        hebLastName: match ? match.lastNameH : "",
        firstName: match ? match.firstName : "",
        lastName: match ? match.lastName : "",
      });
    },
    removeEditDeletedCategory(index) {
      this.editFlagIdsToRemove.push(this.editCategoryFlags[index].flagId);
      this.editCategoryFlags.splice(index, 1);
    },
    findClassExcludeConflicts(studentId, classNumber) {
      const student = this.findStudent(studentId);
      if (!student || classNumber == null || classNumber === 0) return [];
      const target = Number(classNumber);
      const seen = {};
      return []
        .concat(student.excludes || [], student.excludeBy || [])
        .filter((e) => {
          if (e.isDeleted) return false;
          const enrolled = e.enrolledToClass;
          if (!enrolled || enrolled.isDeleted) return false;
          if (Number(enrolled.classNumber) !== target) return false;
          const id = String(e.studentId || "").trim();
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        })
        .map((e) => this.hebName(e) || e.studentId);
    },

    commitEditStudent() {
      if (
        this.editEnrolledClassNumber != this.editEnrolledClassNumberOriginal
      ) {
        const conflicts = this.findClassExcludeConflicts(
          this.editForm.studentId,
          this.editEnrolledClassNumber
        );
        if (conflicts.length) {
          this.classExcludeConflicts = conflicts;
          this.classExcludeConflictDialog = true;
          return;
        }
      }
      this.saveEditStudent();
    },
    confirmClassExcludeConflict() {
      this.classExcludeConflictDialog = false;
      this.saveEditStudent();
    },
    async saveEditStudent() {
      this.commitEditExcludeChip();
      const studentId = this.editForm.studentId;
      const term = this.editForm.term;

      const flagPayloads = this.editCategoryFlags
        .filter((category) => !category.isDeletedCategory && category.value)
        .map((category) => ({
          studentId: studentId,
          term: term,
          category: category.categoryName,
          flag: category.value,
        }));

      const student = this.findStudent(studentId);
      const existingExcludes = (student && student.excludes) || [];
      const existingExcludeIds = existingExcludes.map((e) =>
        String(e.studentId || "").trim()
      );

      const editExcludeIdList = this.editExcludeIds.map((exclude) =>
        String(exclude.studentId || "").trim()
      );

      const excludesToAdd = editExcludeIdList
        .filter((id) => existingExcludeIds.indexOf(id) === -1)
        .map((id) => ({
          studentId: studentId,
          excludeStudentId: id,
          term: term,
        }));

      const excludeIdsToRemove = existingExcludes
        .filter(
          (e) =>
            editExcludeIdList.indexOf(String(e.studentId || "").trim()) === -1
        )
        .map((e) => e.id);

      const promises = [];
      if (flagPayloads.length) {
        promises.push(this.apiAddStudentFlag(flagPayloads));
      }
      if (excludesToAdd.length) {
        promises.push(this.apiAddExcludes(excludesToAdd));
      }
      if (excludeIdsToRemove.length) {
        promises.push(this.apiDeleteExcludes(excludeIdsToRemove));
      }
      if (this.editFlagIdsToRemove.length) {
        promises.push(this.deleteStudentFlag(this.editFlagIdsToRemove));
      }
      if (
        this.editEnrolledClassNumber != this.editEnrolledClassNumberOriginal
      ) {
        promises.push(
          this.$http.post("api/SchoolSplitStudentClasses/Update", {
            Id: this.editEnrolledClassId || 0,
            ClassNumber: this.editEnrolledClassNumber || 0,
            Term: this.selectedTerm,
            SetSplitName: this.selectedSetSplitName,
            StudentId: studentId,
          })
        );
      }

      await Promise.all(promises);

      this.notifySuccess("Student updated successfully.");
      await this.loadAllData();
      this.closeEditStudent();
      this.showSplitRecalcDialog();
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectedStudentIds = this.groupedByStudent.map((g) => g.studentId);
      } else {
        this.selectedStudentIds = [];
      }
    },
    confirmBulkDelete() {
      if (!this.selectedStudentIds.length) return;
      this.deleteStudentsDialog = true;
    },
    async deleteStudents() {
      const flagIds = [];
      const excludeIds = [];
      const enrolledClassIds = [];

      this.selectedStudentIds.forEach((studentId) => {
        const group = this.groupedByStudent.find(
          (g) => g.studentId === studentId
        );
        if (!group) return;
        group.flags.forEach((item) => {
          if (item.id != null) flagIds.push(item.id);
        });
        group.excludes.forEach((entry) => {
          if (entry.id != null) excludeIds.push(entry.id);
        });
        group.enrolledToClasses.forEach((enrolled) => {
          if (enrolled.id != null) enrolledClassIds.push(enrolled.id);
        });
      });
      const promises = [];
      if (flagIds.length) {
        promises.push(this.deleteStudentFlag(flagIds));
      }
      if (excludeIds.length) {
        promises.push(this.apiDeleteExcludes(excludeIds));
      }
      if (enrolledClassIds.length) {
        promises.push(this.apiDeleteClassRows(enrolledClassIds));
      }
      await Promise.all(promises);
      this.notifySuccess("Selected students removed successfully.");
      this.showSplitRecalcDialog();
      await this.loadAllData();
      this.deleteStudentsDialog = false;
      this.selectedStudentIds = [];
    },
    openStudentView(studentId) {
      const route = this.$router.resolve({
        name: "StudentView",
        params: { id: studentId },
      });
      window.open(route.href, "_blank");
    },
    async apiGetAll() {
      this.loading = true;
      try {
        let url = `api/SchoolSplit/getData?term=${encodeURIComponent(
          this.selectedTerm || ""
        )}`;
        if (this.selectedSetSplitName) {
          url += `&setSplitName=${encodeURIComponent(
            this.selectedSetSplitName
          )}`;
        }
        return await this.$http.get(url);
      } catch (error) {
        this.notifyError("Failed to load data.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiAddCategory(payload) {
      this.loading = true;
      try {
        return await this.$http.post(`api/SchoolSplit/AddCategory`, payload);
      } catch (error) {
        this.notifyError("Failed to add category.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiUpdateCategory(payload) {
      this.loading = true;
      try {
        return await this.$http.put(`api/SchoolSplit/UpdateCategory`, payload);
      } catch (error) {
        this.notifyError("Failed to update category.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiDeleteCategory(id) {
      this.loading = true;
      try {
        return await this.$http.put(`api/SchoolSplit/DeleteCategory/${id}`);
      } catch (error) {
        this.notifyError("Failed to delete category.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiAddStudentFlag(payload) {
      this.loading = true;
      try {
        return await this.$http.post(`api/SchoolSplit/AddStudentFlag`, payload);
      } catch (error) {
        this.notifyError("Failed to add record skills.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiAddExcludes(payload) {
      this.loading = true;
      try {
        return await this.$http.post(`api/SchoolSplit/AddExcludes`, payload);
      } catch (error) {
        this.notifyError("Failed to add excludes.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiDeleteExcludes(ids) {
      this.loading = true;
      try {
        return await this.$http.put(`api/SchoolSplit/DeleteExcludes`, ids);
      } catch (error) {
        this.notifyError("Failed to delete excludes.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiDeleteStudentFlag(flagIds) {
      this.loading = true;
      try {
        return await this.$http.put(
          `api/SchoolSplit/DeleteStudentFlag`,
          flagIds
        );
      } catch (error) {
        this.notifyError("Failed to delete record skills.");
        return null;
      } finally {
        this.loading = false;
      }
    },
    async apiDeleteClassRows(ids) {
      this.loading = true;
      try {
        return await this.$http.put(
          `api/SchoolSplitStudentClasses/Delete`,
          ids
        );
      } catch (error) {
        this.notifyError("Failed to delete class rows.");
        return null;
      } finally {
        this.loading = false;
      }
    },

    async deleteStudentFlag(flagIds) {
      await this.apiDeleteStudentFlag(flagIds);
    },

    showSplitRecalcDialog() {
      this.splitRecalcDialog = true;
    },

    closeEditStudent() {
      this.editDialog = false;
      this.editForm = { studentId: "", term: "", class: "" };
      this.editFlagIdsToRemove = [];
      this.editCategoryFlags = [];
      this.editExcludeIds = [];
      this.editNewExcludeId = "";
      this.editEnrolledClassId = null;
      this.editEnrolledClassNumber = null;
      this.editEnrolledClassNumberOriginal = null;
    },

    notifyError(text) {
      this.$notify({
        text: text,
        group: "notification",
        type: "error",
      });
    },
    notifySuccess(text) {
      this.$notify({
        text: text,
        group: "notification",
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
.class-placement {
  position: relative;
}

.class-placement.is-page-loading > *:not(.page-loading-overlay) {
  opacity: 0.4;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.page-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.35);
  z-index: 1000;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
}

.toolbar-action-btn {
  border-radius: 20px !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.toolbar-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.16) !important;
}

.by-student-view {
  padding: 4px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.by-student-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.by-student-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 16px;
  border: 1px dashed #c8e6c9;
  border-radius: 8px;
  background: #f7fbf7;
}

.by-student-empty-title {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #616161;
}

.by-student-empty-hint {
  margin-top: 4px;
  font-size: 13px;
  color: #9e9e9e;
}

.student-group-card {
  display: flex;
  gap: 0;
  border: 1px solid #e0e0e0;
  border-left: 4px solid #5cb860;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  min-width: max-content;
  flex-shrink: 0;
}

.student-group-side {
  display: flex;
  align-items: center;
  width: 190px;
}

.student-group-side-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  flex: 1;
  min-width: 0;
  text-align: center;
}

.student-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #5cb860;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.student-photo-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e8f0ea;
  border: 1px solid #c8dccb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: #5cb860;
}

.student-photo-btn .v-icon {
  color: #5cb860 !important;
}

.student-img-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.45);
  cursor: zoom-out;
}

.student-img-preview {
  width: min(72vw, 320px);
  height: min(72vw, 320px);
  border-radius: 18px;
  object-fit: cover;
  background: #fff;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.35);
  cursor: zoom-out;
}

.student-id-label {
  font-weight: 700;
  font-size: 13px;
  color: #333;
  line-height: 1.25;
}

.student-id-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.student-id-text {
  font-size: 11px;
  font-weight: 700;
  color: #2e7d32;
}

.student-name-label {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.student-meta-row {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: center;
  gap: 3px 8px;
}

.student-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  font-weight: 600;
  color: #616161;
  white-space: nowrap;
  max-width: 55px;
  overflow: hidden;
}

.student-meta-item .v-icon {
  font-size: 10px !important;
  color: #7cb342 !important;
}
.skill-grid-scroll {
  display: flex;
  flex-direction: column;
  gap: 3px;
  overflow: auto;
  max-height: 90vh;
  padding-bottom: 4px;
}

.skill-grid-header-row {
  border-left-color: #9e9e9e;
  min-width: max-content;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

.student-flag-cards {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
  padding: 12px 14px;
}

.flag-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 12px;
  background: linear-gradient(180deg, #fbfdfb 0%, #f5f7f5 100%);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.skill-cube {
  width: 120px;
  flex-shrink: 0;
  min-height: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.skill-cube-header {
  background: #e8f5e9;
  border-color: #c8e6c9;
  color: #2e7d32;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  word-break: break-word;
}

.skill-cube-filled {
  background: #fff;
  border-color: #c8e6c9;
}

.skill-cube-filled:hover {
  border-color: #a5d6a7;
  box-shadow: 0 2px 6px rgba(92, 184, 96, 0.12);
}

.skill-cube-empty {
  background: #f3f6f3;
  border: 1px dashed #d0d7d0;
  color: #b0b8b0;
}

.skill-cube-empty-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #b0b8b0;
  text-transform: uppercase;
}

.flag-card-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 6px;
}

.flag-card-value {
  flex-shrink: 0;
  min-width: 32px;
  height: 32px;
  padding: 0 12px;
  border-radius: 40px;
  background: #5cb860;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.excludes-cell-scroll {
  width: 100%;
  height: 50px;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.exclude-pill {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 4px;
  padding: 2px 6px;
  border-radius: 10px;
  background: #eceff1;
  color: #455a64;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
}

.exclude-pill:last-child {
  margin-bottom: 0;
}

.flags-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 40px;
}

.flag-input {
  max-width: 80px;
  margin: 0 8px;
  padding-top: 0;
}

.category-name-row {
  display: flex;
  align-items: center;
}

.category-row {
  padding: 8px 0;
}

.student-rows-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.student-row {
  position: relative;
  border: 1px solid #e8e8e8;
  border-left: 3px solid #5cb860;
  border-radius: 8px;
  padding: 14px 40px 12px 14px;
  background: linear-gradient(180deg, #fbfdfb 0%, #f5f7f5 100%);
}

.student-row-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.excludes-input-row {
  min-height: 56px;
}

.exclude-input {
  max-width: 130px;
  margin: 0 8px;
  padding-top: 0;
}
.dialog-top {
  align-self: flex-start;
  margin-top: 80px;
}

.toolbar-select-wrap {
  background: #f3f2f2;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1.5px solid #d0d9d1;
  border-radius: 15px;
  padding: 0 12px 0 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s;
}

.toolbar-select-wrap:focus-within {
  border-color: #4caf50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.12);
}

.search-input {
  width: 200px !important;
  flex: 1;
}

.search-input-wrap {
  background: #f3f2f2;
  border: 1.5px solid #d0d9d1;
  border-radius: 15px;
  padding: 0 12px 0 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s;
}

.search-input-wrap:focus-within {
  border-color: #4caf50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.12);
}
.auto-dir-menu {
  direction: rtl;
}
</style>
